const team = [
  {
    picture:
      "https://images03.nicepage.com/c461c07a441a5d220e8feb1a/1dbe2df619b55bc9945896c7/5.jpg",
    name: "Tavera Huarache, Hernando",
    title: "Presidente Ejecutivo",
    scopus: "scopusID",
    cti: "ctiID",
    orcid: "orcID",
    id: "yamina-silva"
  },
  {
    picture:
      "https://images03.nicepage.com/c461c07a441a5d220e8feb1a/a34196cae77150c4bdcce123/7.jpg",
    name: "Silva de Millones, Yamina",
    title: "Jefa del Programa",
    scopus: "scopusID",
    cti: "ctiID",
    orcid: "orcID",
    id: "yamina-silva"
  },
  {
    picture:
      "https://images03.nicepage.com/c461c07a441a5d220e8feb1a/02db0d16743e5259b4926be5/4.jpg",
    name: "Norabuena Ortiz, Edmundo",
    title: "Director Científico",
    scopus: "scopusID",
    cti: "ctiID",
    orcid: "orcID",
    id: "yamina-silva"
  },
  {
    picture:
      "https://images03.nicepage.com/c461c07a441a5d220e8feb1a/a34196cae77150c4bdcce123/7.jpg",
    name: "Norabuena Ortiz, Edmundo",
    title: "Director Científico",
    scopus: "scopusID",
    cti: "ctiID",
    orcid: "orcID",
    id: "yamina-silva"
  },
  {
    picture:
      "https://images03.nicepage.com/c461c07a441a5d220e8feb1a/a34196cae77150c4bdcce123/7.jpg",
    name: "Norabuena Ortiz, Edmundo",
    title: "Director Científico",
    scopus: "scopusID",
    cti: "ctiID",
    orcid: "orcID",
    id: "yamina-silva"
  },
  {
    picture:
      "https://images03.nicepage.com/c461c07a441a5d220e8feb1a/a34196cae77150c4bdcce123/7.jpg",
    name: "Norabuena Ortiz, Edmundo",
    title: "Director Científico",
    scopus: "scopusID",
    cti: "ctiID",
    orcid: "orcID",
    id: "yamina-silva"
  },
  {
    picture:
      "https://images03.nicepage.com/c461c07a441a5d220e8feb1a/a34196cae77150c4bdcce123/7.jpg",
    name: "Norabuena Ortiz, Edmundo",
    title: "Director Científico",
    scopus: "scopusID",
    cti: "ctiID",
    orcid: "orcID",
    id: "yamina-silva"
  },
  {
    picture:
      "https://images03.nicepage.com/c461c07a441a5d220e8feb1a/a34196cae77150c4bdcce123/7.jpg",
    name: "Norabuena Ortiz, Edmundo",
    title: "Director Científico",
    scopus: "scopusID",
    cti: "ctiID",
    orcid: "orcID",
    id: "yamina-silva"
  },
  {
    picture:
      "https://images03.nicepage.com/c461c07a441a5d220e8feb1a/a34196cae77150c4bdcce123/7.jpg",
    name: "Norabuena Ortiz, Edmundo",
    title: "Director Científico",
    scopus: "scopusID",
    cti: "ctiID",
    orcid: "orcID",
    id: "yamina-silva"
  }
];

const getTeam = () => {
  return team;
};

export { getTeam };
